// Types
import { RootState } from 'types/RootState.types';

export const getRouterLocationSelector = (state: RootState) => state.router?.location;
export const getRouterLocationPathname = (state: RootState) => state.router?.location?.pathname || '';
export const getRouterLocationSearchSelector = (state: RootState) => state.router?.location?.search || '';
